import { AddressTypeEnum } from '../../../components/Address/adress.enum';
import { CustomerFilter } from '../../../components/Crud/filter.types';
import LangEnum from '../../../lang/LangEnum';
import { LangEnumOption } from '../../../lib/OptionsLib';
import {
  Connection,
  Invite,
  InviteBrandStatus,
  InviteStoreStatus,
} from '../../my-network/myNetwork.types';
import { PriceTable } from '../../price-tables/price-table.types';
import { SalesRepresentative } from '../../sales-representative/sales-representative.types';
import { StoreStatus, StoreStatusEnum } from '../../store-admin/store.types';
import { LicenseType, UserPosition, UserRole } from '../../users/roles';
import { CustomerOriginType, CustomerSynchronizedStatus } from './customer.enum';
import { CustomerStatusType } from './customerStatusType';

export type SellerGroup = {
  id: string;
  name: string;
  code: string;
  sellers: Seller[];
};

export type Address = {
  id: string;
  zipCode: string;
  streetDescription: string;
  streetNumber?: string;
  complement?: string;
  reference?: string;
  neighborhood?: string;
  city: string;
  state: string;
  country: string;
  code?: string;
  type: AddressTypeEnum;
};

export type CustomerAddress = {
  id: string;
  address: Address;
  principal: boolean;
};

export type Consultant = {
  id: string;
  name: string;
  code: string;
  brandId: string;
  active: boolean;
};

export type Seller = {
  id: string;
  userId: string;
  contextId: string;
  email: string;
  name: string;
  surname: string;
  phone: string;
  position: UserPosition;
  role: UserRole;
  roleName: string;
  lastAccess: Date;
  licenseType: LicenseType;
  sellerGroup: SellerGroup;
  salesRepresentative?: any;
};

export type InviteStatus = {
  brandStatus: InviteBrandStatus;
  storeStatus: InviteStoreStatus;
};

export interface Customer {
  addresses?: CustomerAddress[];
  commercialName: string;
  customerGroupName: string;
  email: string;
  id: string;
  isPJ: boolean;
  location: string;
  status: CustomerStatusType;
  synchronized: CustomerSynchronizedStatus;
  createdAt: string;
  updatedAt: string;
  origin: CustomerOriginType;
  storeId?: string;
  storeStatus?: StoreStatusEnum;
  storeVerified?: boolean;
  salesRepresentatives?: SalesRepresentative[];
  code?: string;
  companyName?: string;
  connection?: Connection | null;
  countryCode?: string;
  cpfcnpj?: string;
  customerGroupId?: string | null;
  invite?: Invite | null;
  phone?: string;
  stateInscription?: string;
  suframaCode?: string | null;
  priceTable?: PriceTable | null;
  createdBy?: CustomerCreatedBy;
}

export type CustomerCreatedBy = {
  id: string;
  name: string;
  surname: string;
};

export type CustomerOptions = Customer | CustomerAutocomplete;

export interface CustomerAutocomplete {
  id: string;
  commercialName: string;
  companyName: string;
  cpfcnpj?: string;
  code?: string;
  city?: string;
  state?: string;
  principal?: string;
}

export type CustomerOrContact = {
  id: string;
  customerId: string;
  email: string;
  companyName?: string;
  name?: string;
  surname?: string;
  invite: InviteStatus;
  connection: Connection;
  storeStatus: StoreStatus;
};

export type EmailWithIdInviteCustomerDTO = {
  customerId: string;
  email: string;
};

export type InviteCustomerDTO = {
  customers: EmailWithIdInviteCustomerDTO[];
  connectionInviteOnStoreSignUp?: boolean;
  customerFilter?: Partial<CustomerFilter> | null;
  message?: string;
  type: string;
};

export enum DocumentType {
  CNPJ = 'CNPJ',
  CPF = 'CPF',
  TAX_ID = 'TAX_ID',
  NIF = 'NIF',
  PASSPORT = 'PASSPORT',
  OTHERS = 'OTHER',
}

export const customerStatusTypesSelect: Array<LangEnumOption> = [
  {
    label: LangEnum.CUSTOMER_STATUS_PENDING,
    value: CustomerStatusType.PENDING,
  },
  {
    label: LangEnum.CUSTOMER_STATUS_APPROVED,
    value: CustomerStatusType.APPROVED,
  },
];

export const customerSynchronizedTypesSelect: Array<LangEnumOption> = [
  {
    label: LangEnum.ORDER_SYNC_STATUS_SUCCESS,
    value: 'SUCCESS',
  },
  {
    label: LangEnum.GLOBAL_ERROR,
    value: 'ERROR',
  },
  {
    label: LangEnum.GLOBAL_PROCESSING,
    value: 'PROCESSING',
  },
  {
    label: LangEnum.ORDER_FILTER_NOT_SYNC_LABEL,
    value: 'NOT_SYNCHRONIZED',
  },
];

export interface CustomerBlockingReason {
  id: string;
  reason: string;
  integrationCode: string;
}

export type BatchConnectRequestDTO = {
  customerIds?: string[];
  customerFilter?: Partial<CustomerFilter> | null;
  message?: string;
  acceptUnverified?: boolean;
};

export type BatchDisconnectRequestDTO = {
  customerIds?: string[];
  customerFilter?: Partial<CustomerFilter> | null;
};
